// extracted by mini-css-extract-plugin
module.exports = {"root":"RemoveImageButton_root__2oLpI"};